export default {
  title: '商品カテゴリ',
  addPrimary: '一次カテゴリ追加',
  addSecondary: '二次カテゴリ追加',
  collapseAll: 'すべてのカテゴリを折りたたむ',
  language: '言語',
  categoryName: 'カテゴリ名',
  categoryNamePlaceholder: 'カテゴリ名を入力してください',
  searchPlaceholder: 'キーワードで検索してください',
  giftCount: 'ギフト数',
  modify: '変更',
  multilingual: '多言語',
  addPrimaryTitle: '一次カテゴリを追加',
  addSecondaryTitle: '二次カテゴリを追加',
  editTitle: 'カテゴリを変更',
  multiLangTitle: '多言語',
  deleteIrreversible: '削除後に復元できません。削除しますか？',
  langRequired: '言語を選択してください',
  nameRequired: 'カテゴリ名を入力してください',
  firstAddTip:
    '初回追加時はシステムのデフォルト言語が使用され、【多言語】をクリックした場合はデフォルトのリスト検索条件で選択された言語が使用されます',
};
